
"use client";

import { useState } from "react";
import axios from "axios";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { EditUserModal } from "./edit-user-modal";
import { DeleteUserDialog } from "./delete-user-dialog";
import { User } from "./user-schema";

interface DataTableRowActionsProps {
  row: { original: User };
  fetchUsers: () => void;
}

export function DataTableRowActions({ row, fetchUsers }: DataTableRowActionsProps) {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteDialogVisible, setIsDeleteDialogVisible] = useState(false);

  const handleEdit = () => {
    setIsEditModalOpen(true);
  };

  const handleDelete = () => {
    setIsDeleteDialogVisible(true);
  };

  const onEditUser = async (userData: User) => {
    try {
      const accessToken = localStorage.getItem("accessToken");
      await axios.put(`${import.meta.env.VITE_API_URL}/user`, userData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      setIsEditModalOpen(false);
      fetchUsers();
    } catch (error) {
      console.error("Failed to edit user:", error);
    }
  };

  const onDeleteUser = async () => {
    try {
      const accessToken = localStorage.getItem("accessToken");
      await axios.delete(
        `${import.meta.env.VITE_API_URL}/user/${row.original.id}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      setIsDeleteDialogVisible(false);
      fetchUsers();
    } catch (error) {
      console.error("Failed to delete user:", error);
    }
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            className="flex h-8 w-8 p-0 data-[state=open]:bg-muted"
          >
            <span className="sr-only">Open menu</span>
            ...
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-[160px]">
          <DropdownMenuItem onClick={handleEdit}>Edit</DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={handleDelete}>
            Delete
            <DropdownMenuShortcut>⌘⌫</DropdownMenuShortcut>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <EditUserModal
        open={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        onEditUser={onEditUser}
        userData={row.original}
      />
      <DeleteUserDialog
        open={isDeleteDialogVisible}
        onClose={() => setIsDeleteDialogVisible(false)}
        onConfirm={onDeleteUser}
      />
    </>
  );
}
